import LandingLayout from "components/common/landingLayout";
import DigitalSolutionB from "components/digitalSolutionB";
import React from "react";

const DigitalSolutionBPage = () => {
  return (
    <LandingLayout>
      <DigitalSolutionB />
    </LandingLayout>
  );
};

export default DigitalSolutionBPage;
